import _ from 'lodash';

const entitySelector = (entity, results, entityKey, resultKey) => {
  resultKey = resultKey || entityKey;
  results[resultKey] = !!results[resultKey] ? results[resultKey] : {},
  entity[entityKey] = !!entity[entityKey] ? entity[entityKey] : {};

  const resultId = !!results[resultKey].id ? results[resultKey].id: results[resultKey],
        entityObj = !!entity[entityKey][resultId] ? entity[entityKey][resultId] : null;
  return entityObj;
}

const entitiesSelector = (entity, results, entityKey, resultKey) => {
  resultKey = resultKey || entityKey;
  results[resultKey] = !!results[resultKey] ? results[resultKey] : [];

  const selectedEntities = results[resultKey].filter((result) => {
    if (!!result) return true;
    else {
      console.error('Error retrieving the list results for schema definition: ' + entityKey + ', and list: ' + JSON.stringify(entity));
      return false
    }
  }).map((result) => {
    const resultId = !!result.id ? result.id : result;
    return entity[entityKey][resultId];
  });
  return selectedEntities;
}

const entityErrorByKeywords = (errors, keywords) => {
  for (var index = 0 ; index < keywords.length ; index ++) {
    const error = entityErrorByKeyword(errors, keywords[index]);
    if (!_.isEmpty(error)) return error;
  }
  return null;
}

const entityErrorByKeyword = (errors, keyword) => {
  const error = {};
  if (!_.isEmpty(errors)) {
    const keyLenght = Object.keys(errors).length || 0;
    var aux = 0;
    while (aux < keyLenght && _.has(errors[aux], 'message')) {
      if (_.contains(errors[aux].message, keyword)) {
        Object.assign(error, errors[aux]);
        break;
      }
      aux++;
    }
  }
  return error;
}

module.exports = {
  entitySelector,
  entitiesSelector,
  entityErrorByKeyword,
  entityErrorByKeywords
};



// WEBPACK FOOTER //
// ./src/helpers/entitySelector.jsx